import { Fragment } from 'react/jsx-runtime'
import { motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'
import axios from 'axios'

import { Footer, Header, Sakura, Text } from '@/components'
import { currency } from '@/utils'
import { useEffect, useState } from 'react'

type Promo = {
	id: number
	period: {
		start: string
		end: string
	}
	name: string
	description: string
	active: boolean
	photos: string[]
	promo_category: {
		id: number
		code: string
		name: string
	}
	store: {
		active: number
		altitude: number
		code: string
		contact_email: string
		contact_name: string
		contact_phone: string
		floor: string
		id: number
		image: string
		latitude: number
		longitude: number
		name: string
		name_with_client: string
		note: string
		qr_code: string
		unit: string
		visible: number
	}
}

export const Home = () => {
	const { t } = useTranslation()

	const [currentSlide, setCurrentSlide] = useState<number>(0)
	const [ref, slider] = useKeenSlider<HTMLDivElement>({
		loop: true,
		mode: 'snap',
		renderMode: 'performance',
		slides: {
			perView: 4,
			spacing: 16
		},
		breakpoints: {
			'(max-width: 1024px)': {
				slides: { perView: 3, spacing: 12 }
			},
			'(max-width: 768px)': {
				slides: { perView: 2, spacing: 10 }
			},
			'(max-width: 480px)': {
				slides: { perView: 1, spacing: 8 }
			}
		},
		slideChanged(s) {
			setCurrentSlide(s.track.details.rel)
		}
	})

	const [promo, setPromo] = useState<Promo[]>([])

	const [refPromo] = useKeenSlider<HTMLDivElement>(
		{
			loop: true
		},
		[
			slider => {
				let timeout: ReturnType<typeof setTimeout>
				let mouseOver = false
				function clearNextTimeout() {
					clearTimeout(timeout)
				}
				function nextTimeout() {
					clearTimeout(timeout)
					if (mouseOver) return
					timeout = setTimeout(() => {
						slider.next()
					}, 1000)
				}
				slider.on('created', () => {
					slider.container.addEventListener('mouseover', () => {
						mouseOver = true
						clearNextTimeout()
					})
					slider.container.addEventListener('mouseout', () => {
						mouseOver = false
						nextTimeout()
					})
					nextTimeout()
				})
				slider.on('dragStarted', clearNextTimeout)
				slider.on('animationEnded', nextTimeout)
				slider.on('updated', nextTimeout)
			}
		]
	)

	const products = [
		{
			id: 379,
			code: 'ES-07-001-0005',
			name: 'Seoul Set',
			image_url:
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450843871-1.png',
			min_quantity: null,
			weight: '100',
			remark:
				'1. Arirang Meals Box Bone Marrow Noodle \nMie rasa sumsum sapi asli, teksturnya lembut dan aroma yang gurih serta rasanya creamy dan cukup dengan air biasa. Dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n2. Arirang Meals Box Hot Fried Noodle \nMie goreng  yang memberikan rasa pedas dengan dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n3. Arirang Truffle Creamy Ramyeon\nMie dengan jamur truffle yang menghadirkan aroma menggugah selera dan cita rasa lezat bagi pencinta tekstur creamy.\n\n*Bonus di Pembelian ke-3 dan ke-6 : \n- Arirang Foldable Bag with Pouch \n- Boneka Arirange Keychain',
			mst_unit_of_measurements: {
				name: 'PCS'
			},
			mst_item_brands: {
				id: 19,
				code: 'GAGA',
				name: 'GAGA',
				image_url:
					'https://nos.wjv-1.neo.id/supplybox-dev/brands/1739848493655-GAGA.png'
			},
			images: [
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450843871-1.png',
				'https://nos.wjv-1.neo.id/supplybox/brands/1766451328139-2.png'
			],
			wholesale_prices: [],
			sales_price: '50000'
		},
		{
			id: 380,
			code: 'ES-09-001-0004',
			name: 'Busan Set',
			image_url:
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450900404-3.png',
			min_quantity: null,
			weight: '100',
			remark:
				'1. Arirang Meals Box Bone Marrow Rice Noodle\nKwetiau rasa sumsum sapi asli, teksturnya lembut dan aroma yang gurih serta rasanya creamy dan cukup dengan air biasa. Dilengkapi potongan daging plant based (TVP) sebagai toppingnya. \n2. Arirang Meals Box Hot Chicken Fried Rice Noodle \nMie goreng rasa ayam yang memberikan rasa pedas dengan dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n3. Arirang Truffle Creamy Ramyeon\nMie dengan jamur truffle yang menghadirkan aroma menggugah selera dan cita rasa lezat bagi pencinta tekstur creamy.\n\n*Bonus di Pembelian ke-3 dan ke-6 : \n- Arirang Foldable Bag with Pouch \n- Boneka Arirange Keychain',
			mst_unit_of_measurements: {
				name: 'PCS'
			},
			mst_item_brands: {
				id: 19,
				code: 'GAGA',
				name: 'GAGA',
				image_url:
					'https://nos.wjv-1.neo.id/supplybox-dev/brands/1739848493655-GAGA.png'
			},
			images: [
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450900404-3.png',
				'https://nos.wjv-1.neo.id/supplybox/brands/1766400985222-4.png'
			],
			wholesale_prices: [],
			sales_price: '50000'
		},
		{
			id: 381,
			code: 'OT-01-001-0002',
			name: 'Jeju Set',
			image_url:
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450990128-5.png',
			min_quantity: null,
			weight: '100',
			remark:
				'1. Arirang Meals Box Bone Marrow Noodle \nMie rasa sumsum sapi asli, teksturnya lembut dan aroma yang gurih serta rasanya creamy dan cukup dengan air biasa. Dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n2. Arirang Meals Box Hot Fried Noodle \nMie goreng  yang memberikan rasa pedas dengan dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n3. Arirang Meals Box Seafood \nRice noodle otentik Korea dengan perpaduan kaldu Seafood yang gurih dan kaya rasa. Terbuat dari mie beras, lebih ringan di perut dan cocok untuk yang ingin pilihan sehat atau menghindari gluten. \n4. Arirang Truffle Creamy Ramyeon\nMie dengan jamur truffle yang menghadirkan aroma menggugah selera dan cita rasa lezat bagi pencinta tekstur creamy.  \n\n*Bonus di Pembelian ke-3 dan ke-6 : \n- Arirang Foldable Bag with Pouch \n- Boneka Arirange Keychain',
			mst_unit_of_measurements: {
				name: 'PCS'
			},
			mst_item_brands: {
				id: 19,
				code: 'GAGA',
				name: 'GAGA',
				image_url:
					'https://nos.wjv-1.neo.id/supplybox-dev/brands/1739848493655-GAGA.png'
			},
			images: [
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450990128-5.png',
				'https://nos.wjv-1.neo.id/supplybox/brands/1766401072124-6.png'
			],
			wholesale_prices: [],
			sales_price: '75000'
		},
		{
			id: 382,
			code: 'ES-04-002-0005',
			name: 'Gangnam Set',
			image_url:
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450946401-7.png',
			min_quantity: null,
			weight: '100',
			remark:
				'1. Arirang Meals Box Bone Marrow Rice Noodle \nKwetiau rasa sumsum sapi asli, teksturnya lembut dan aroma yang gurih serta rasanya creamy dan cukup dengan air biasa. Dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n2. Arirang Meals Box Hot Chicken Fried Rice Noodle \nMie goreng rasa ayam yang memberikan rasa pedas dengan dilengkapi potongan daging plant based (TVP) sebagai toppingnya.\n3. Arirang Meals Box Kimchi \nRice noodle dengan sensasi pedas-asam Kimchi otentik Korea yang menggugah selera. Terbuat dari mie beras, lebih ringan di perut dan cocok untuk yang ingin pilihan sehat atau menghindari gluten.   \n4. Arirang Truffle Creamy Ramyeon\nMie dengan jamur truffle yang menghadirkan aroma menggugah selera dan cita rasa lezat bagi pencinta tekstur creamy.  \n\n*Bonus di Pembelian ke-3 dan ke-6 : \n- Arirang Foldable Bag with Pouch \n- Boneka Arirange Keychain',
			mst_unit_of_measurements: {
				name: 'PCS'
			},
			mst_item_brands: {
				id: 19,
				code: 'GAGA',
				name: 'GAGA',
				image_url:
					'https://nos.wjv-1.neo.id/supplybox-dev/brands/1739848493655-GAGA.png'
			},
			images: [
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450946401-7.png',
				'https://nos.wjv-1.neo.id/supplybox/brands/1766401034159-8.png'
			],
			wholesale_prices: [],
			sales_price: '75000'
		},
		{
			id: 383,
			code: 'ES-07-003-0004',
			name: 'Daegu Set',
			image_url:
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450927468-9.png',
			min_quantity: null,
			weight: '100',
			remark:
				'1. Arirang Meals Box Bone Marrow Noodle \nMie rasa sumsum sapi asli, teksturnya lembut dan aroma yang gurih serta rasanya creamy dan cukup dengan air biasa. Dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n2. Arirang Meals Box Hot Fried Noodle \nMie goreng  yang memberikan rasa pedas dengan dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n3. Arirang Meals Box Seafood \nRice noodle otentik Korea dengan perpaduan kaldu Seafood yang gurih dan kaya rasa. Terbuat dari mie beras, lebih ringan di perut dan cocok untuk yang ingin pilihan sehat atau menghindari gluten.   \n4. Arirang Meals Box Kimchi \nRice noodle dengan sensasi pedas-asam Kimchi otentik Korea yang menggugah selera. Terbuat dari mie beras, lebih ringan di perut dan cocok untuk yang ingin pilihan sehat atau menghindari gluten.   \n5. Arirang Truffle Creamy Ramyeon\nMie dengan jamur truffle yang menghadirkan aroma menggugah selera dan cita rasa lezat bagi pencinta tekstur creamy.  \n \n*Bonus di Pembelian ke-3 dan ke-6 : \n- Arirang Foldable Bag with Pouch \n- Boneka Arirange Keychain',
			mst_unit_of_measurements: {
				name: 'PCS'
			},
			mst_item_brands: {
				id: 19,
				code: 'GAGA',
				name: 'GAGA',
				image_url:
					'https://nos.wjv-1.neo.id/supplybox-dev/brands/1739848493655-GAGA.png'
			},
			images: [
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450927468-9.png',
				'https://nos.wjv-1.neo.id/supplybox/brands/1766401008479-10.png'
			],
			wholesale_prices: [],
			sales_price: '100000'
		},
		{
			id: 384,
			code: 'ES-09-001-0005',
			name: 'Gyeonggi Set',
			image_url:
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450969221-11.png',
			min_quantity: null,
			weight: '100',
			remark:
				'1. Arirang Meals Box Bone Marrow Rice Noodle \nKwetiau rasa sumsum sapi asli, teksturnya lembut dan aroma yang gurih serta rasanya creamy dan cukup dengan air biasa. Dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n2. Arirang Meals Box Hot Chicken Fried Rice Noodle \nMie goreng rasa ayam yang memberikan rasa pedas dengan dilengkapi potongan daging plant based (TVP) sebagai toppingnya.   \n3. Arirang Meals Box Seafood \nRice noodle otentik Korea dengan perpaduan kaldu Seafood yang gurih dan kaya rasa. Terbuat dari mie beras, lebih ringan di perut dan cocok untuk yang ingin pilihan sehat atau menghindari gluten.   \n4. Arirang Meals Box Kimchi \nRice noodle dengan sensasi pedas-asam Kimchi otentik Korea yang menggugah selera. Terbuat dari mie beras, lebih ringan di perut dan cocok untuk yang ingin pilihan sehat atau menghindari gluten.  \n5. Arirang Truffle Creamy Ramyeon\nMie dengan jamur truffle yang menghadirkan aroma menggugah selera dan cita rasa lezat bagi pencinta tekstur creamy. \n\n*Bonus di Pembelian ke-3 dan ke-6 : \n- Arirang Foldable Bag with Pouch \n- Boneka Arirange Keychain',
			mst_unit_of_measurements: {
				name: 'PCS'
			},
			mst_item_brands: {
				id: 19,
				code: 'GAGA',
				name: 'GAGA',
				image_url:
					'https://nos.wjv-1.neo.id/supplybox-dev/brands/1739848493655-GAGA.png'
			},
			images: [
				'https://nos.wjv-1.neo.id/supplybox/brands/1766450969221-11.png',
				'https://nos.wjv-1.neo.id/supplybox/brands/1766401053792-12.png'
			],
			wholesale_prices: [],
			sales_price: '100000'
		}
	]

	useEffect(() => {
		const getPromo = async () => {
			const res = await axios.get(
				'https://connect-platform-api.loyal.id/api/v1/promotion?page=1&limit=100&status=running&client_code=130801'
			)
			setPromo(res.data.data)
		}

		getPromo()
	}, [])

	return (
		<Fragment>
			<Header />
			<section
				id="home"
				className="relative flex flex-col justify-center items-center md:h-[calc(100vh+80px)] sm:py-40 md:py-0 py-24 bg-fixed xl:px-20 lg:px-10 md:px-14 px-4 bg-gradient-to-br from-[#839DEC] via-[#EAEFFF] to-[#EAEFFF] overflow-hidden"
			>
				<motion.div className="xl:h-full flex justify-between items-center md:flex-nowrap flex-wrap">
					<div className="sm:basis-1/2 md:pr-7 basis-full mx-auto">
						<motion.img
							className="w-full origin-bottom"
							initial={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{
								duration: 1,
								ease: 'easeOut'
							}}
							src={require('@/assets/images/jeongja.png')}
							alt="arirang"
						/>
					</div>
					<div className="sm:basis-1/2 basis-full mx-auto">
						<div className="flex flex-col gap-5">
							<div className="font-light md:text-left xl:text-5xl lg:text-4xl md:text-3xl sm:mt-0 mt-6 text-2xl text-center text-blue-800 whitespace-nowrap">
								<Text speed={1} className="font-light">
									Arirang Meals Cup
								</Text>
							</div>
							<div>
								<div className="font-black md:text-left xl:text-6xl xl:leading-[80px] lg:text-5xl md:text-4xl sm:text-3xl text-2xl text-center text-blue-800 whitespace-nowrap uppercase">
									<Text speed={1} nowrap>
										Shake, Eat, Enjoy,
									</Text>
								</div>
								<div className="flex items-center md:justify-start justify-center">
									<div className="font-black md:text-left xl:text-6xl xl:leading-[80px] lg:text-5xl md:text-4xl sm:text-3xl text-2xl text-center text-blue-800 whitespace-nowrap uppercase">
										<Text speed={1} delay={1} nowrap>
											and Fly to K
										</Text>
									</div>
									<motion.img
										className="sm:h-14 h-6"
										initial={{ opacity: 0, scale: 0, x: 40 }}
										animate={{ opacity: 1, scale: 1, x: 0 }}
										transition={{
											delay: 2.1,
											duration: 1,
											ease: 'easeOut'
										}}
										src={require('@/assets/images/flag.png')}
										alt="arirang"
									/>
									<span className="font-black md:text-left xl:text-6xl xl:leading-[80px] lg:text-5xl md:text-4xl sm:text-3xl text-2xl text-center text-blue-800 whitespace-nowrap uppercase">
										<Text speed={1} delay={2.2} nowrap>
											rea
										</Text>
									</span>
								</div>
							</div>
							<motion.div
								initial={{ opacity: 0, y: 10 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{
									delay: 2.1,
									duration: 0.5,
									ease: 'easeOut'
								}}
								className="font-normal md:text-left xl:text-2xl lg:text-xl md:text-lg text-center text-base text-neutral-600 xl:whitespace-pre-line"
							>
								{t('home_description')}
							</motion.div>
							<motion.div
								initial={{ opacity: 0, y: 10 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{
									delay: 2.5,
									duration: 0.5,
									ease: 'easeOut'
								}}
								className="flex lg:flex-row flex-col gap-4 mt-4"
							>
								<a
									href="https://shake.arirang.co.id/member"
									className="w-full flex justify-center items-center sm:h-12 h-10 px-2 border border-blue-600 rounded-full transition-all duration-300 hover:font-bold"
								>
									<span className="xl:text-lg lg:text-sm md:text-base text-sm text-blue-600">
										{t('login_now')}
									</span>
								</a>
								<a
									href="https://shake.arirang.co.id/member/register"
									className="w-full flex justify-center items-center sm:h-12 h-10 px-2 border bg-blue-600 border-blue-600 rounded-full transition-all duration-300 hover:font-bold"
								>
									<span className="xl:text-lg lg:text-sm md:text-base text-sm text-white line-clamp-1 overflow-hidden">
										{t('register_and_collect_point')}
									</span>
								</a>
							</motion.div>
						</div>
					</div>
				</motion.div>
				<Sakura />
				<img
					className="absolute bottom-0 left-0 w-full z-50"
					src={require('@/assets/images/wave.png')}
					alt="arirang"
				/>
			</section>
			<section id="program" className="pt-20 pb-10">
				<div className="flex items-center md:flex-nowrap flex-wrap xl:px-20 lg:px-10 md:px-14 px-4 bg-white">
					<div className="md:basis-1/2 basis-full">
						<motion.div
							initial={{ opacity: 0, y: 50 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{
								delay: 0.3,
								duration: 0.5,
								ease: 'easeOut'
							}}
							className="md:text-left text-center font-bold xl:text-5xl lg:text-4xl md:text-3xl sm:text-2xl text-xl text-blue-600 md:whitespace-pre-line"
						>
							{t('step_title')}
						</motion.div>
					</div>
					<div className="md:basis-1/2 basis-full md:mt-0 mt-4">
						<motion.div
							initial={{ opacity: 0, y: 50 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{
								delay: 0.3,
								duration: 0.5,
								ease: 'easeOut'
							}}
							className="md:text-left text-center text-base text-neutral-600"
						>
							{t('step_description')}
						</motion.div>
					</div>
				</div>
				<div className="flex md:flex-nowrap flex-wrap xl:px-20 lg:px-10 md:px-14 px-4 bg-white mt-12">
					<div className="md:basis-1/2 basis-full">
						<motion.img
							initial={{ scale: 0 }}
							whileInView={{ scale: 1 }}
							transition={{
								duration: 0.5,
								ease: 'easeOut'
							}}
							className="w-full md:pr-24"
							src={require('@/assets/images/trip.png')}
							alt="arirang"
						/>
					</div>
					<div className="md:basis-1/2 basis-full">
						<div>
							<div className="relative md:pb-12 pb-5 sm:mt-0 mt-10">
								<motion.div
									initial={{ scaleY: 0 }}
									whileInView={{ scaleY: 1 }}
									transition={{
										delay: 0.3,
										duration: 0.5,
										ease: 'easeOut'
									}}
									className="absolute md:top-7 md:left-7 top-5 left-5 h-full bg-blue-600 border-r border-dashed origin-top"
								/>
								<div className="flex md:gap-7 gap-4 items-center">
									<motion.div
										initial={{ scale: 0 }}
										whileInView={{ scale: 1 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="flex justify-center items-center shrink-0 md:w-14 md:h-14 w-10 h-10 bg-blue-600 rounded-full z-10"
									>
										<span className="font-bold md:text-3xl text-xl text-white">
											1
										</span>
									</motion.div>
									<motion.div
										initial={{ opacity: 0, x: 50 }}
										whileInView={{ opacity: 1, x: 0 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="font-bold md:text-3xl text-xl text-blue-950"
									>
										{t('step_1_title')}
									</motion.div>
								</div>
								<motion.div
									initial={{ opacity: 0, x: 50 }}
									whileInView={{ opacity: 1, x: 0 }}
									transition={{
										duration: 0.5,
										ease: 'easeOut'
									}}
									className="md:pl-[84px] pl-[57px]"
								>
									<div className="font-normal text-base text-blue-900">
										{t('step_1_description')}
									</div>
								</motion.div>
							</div>
							<div className="relative md:pb-12 pb-5">
								<motion.div
									initial={{ scaleY: 0 }}
									whileInView={{ scaleY: 1 }}
									transition={{
										delay: 0.3,
										duration: 0.5,
										ease: 'easeOut'
									}}
									className="absolute md:top-7 md:left-7 top-5 left-5 h-full bg-blue-600 border-r border-dashed origin-top"
								/>
								<div className="flex md:gap-7 gap-4 items-center">
									<motion.div
										initial={{ scale: 0 }}
										whileInView={{ scale: 1 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="flex justify-center items-center shrink-0 md:w-14 md:h-14 w-10 h-10 bg-blue-600 rounded-full z-10"
									>
										<span className="font-bold md:text-3xl text-xl text-white">
											2
										</span>
									</motion.div>
									<motion.div
										initial={{ opacity: 0, x: 50 }}
										whileInView={{ opacity: 1, x: 0 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="font-bold md:text-3xl text-xl text-blue-950"
									>
										{t('step_2_title')}
									</motion.div>
								</div>
								<div className="md:pl-[84px] pl-[57px]">
									<motion.div
										initial={{ opacity: 0, x: 50 }}
										whileInView={{ opacity: 1, x: 0 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="font-normal text-base text-blue-900"
									>
										{t('step_2_description')}
									</motion.div>
								</div>
							</div>
							<div className="pb-12">
								<div className="flex md:gap-7 gap-4 items-center">
									<motion.div
										initial={{ scale: 0 }}
										whileInView={{ scale: 1 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="flex justify-center items-center shrink-0 md:w-14 md:h-14 w-10 h-10 bg-blue-600 rounded-full z-10"
									>
										<span className="font-bold md:text-3xl text-xl text-white">
											3
										</span>
									</motion.div>
									<motion.div
										initial={{ opacity: 0, x: 50 }}
										whileInView={{ opacity: 1, x: 0 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="font-bold md:text-3xl text-xl text-blue-950"
									>
										{t('step_3_title')}
									</motion.div>
								</div>
								<div className="md:pl-[84px] pl-[57px]">
									<motion.div
										initial={{ opacity: 0, x: 50 }}
										whileInView={{ opacity: 1, x: 0 }}
										transition={{
											duration: 0.5,
											ease: 'easeOut'
										}}
										className="font-normal text-base text-blue-900"
									>
										{t('step_3_description')}
									</motion.div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section>
				{promo.length > 0 && (
					<div ref={refPromo} className="keen-slider mt-10">
						{promo.map((item, index) => (
							<div className="keen-slider__slide" key={index}>
								<img className="w-full" src={item.photos[0]} alt="promo" />
							</div>
						))}
					</div>
				)}
			</section>
			<section id="product">
				<div className="bg-blue-20 py-20">
					<div className="xl:px-20 lg:px-10 md:px-14 px-4 flex items-center md:flex-nowrap flex-wrap">
						<div className="md:basis-1/2 basis-full">
							<motion.div
								initial={{ opacity: 0, y: 50 }}
								whileInView={{ opacity: 1, y: 0 }}
								transition={{
									delay: 0.3,
									duration: 0.5,
									ease: 'easeOut'
								}}
								className="md:text-left text-center font-bold xl:text-5xl lg:text-4xl md:text-3xl sm:text-2xl text-xl text-blue-600 md:whitespace-pre-line"
							>
								{t('product_title')}
							</motion.div>
						</div>
						<div className="md:basis-1/2 basis-full md:mt-0 mt-4">
							<motion.div
								initial={{ opacity: 0, y: 50 }}
								whileInView={{ opacity: 1, y: 0 }}
								transition={{
									delay: 0.3,
									duration: 0.5,
									ease: 'easeOut'
								}}
								className="md:text-left text-center text-base text-neutral-600"
							>
								{t('product_description')}
							</motion.div>
						</div>
					</div>
					{/* <div className="flex sm:flex-row flex-col justify-around gap-8 mt-12">
						<div className="basis-1/3">
							<motion.div
								initial={{ scale: 0 }}
								whileInView={{ scale: 1 }}
								transition={{
									duration: 0.5,
									ease: 'easeOut'
								}}
								className="flex flex-col gap-4 justify-center items-center"
							>
								<img
									className="w-full"
									src={require('@/assets/images/package-1.png')}
									alt="arirang"
								/>
								<motion.div
									initial={{ scale: 0 }}
									whileInView={{ scale: 1 }}
									transition={{
										delay: 0.2,
										duration: 0.5,
										ease: 'easeOut'
									}}
								>
									<div className="text-center font-bold md:text-2xl text-xl text-blue-600">
										Arirang Package 1
									</div>
									<div className="text-center font-bold md:text-2xl text-xl text-blue-600">
										Rp 50.000
									</div>
								</motion.div>
							</motion.div>
						</div>
						<div className="basis-1/3">
							<motion.div
								initial={{ scale: 0 }}
								whileInView={{ scale: 1 }}
								transition={{
									duration: 0.5,
									ease: 'easeOut'
								}}
								className="flex flex-col gap-4 justify-center items-center"
							>
								<img
									className="w-full"
									src={require('@/assets/images/package-2.png')}
									alt="arirang"
								/>
								<motion.div
									initial={{ scale: 0 }}
									whileInView={{ scale: 1 }}
									transition={{
										delay: 0.2,
										duration: 0.5,
										ease: 'easeOut'
									}}
								>
									<div className="text-center font-bold md:text-2xl text-xl text-blue-600">
										Arirang Package 2
									</div>
									<div className="text-center font-bold md:text-2xl text-xl text-blue-600">
										Rp 75.000
									</div>
								</motion.div>
							</motion.div>
						</div>
					</div> */}
					<div ref={ref} className="keen-slider mt-10">
						{products.map((item, index) => (
							<div key={index} className="keen-slider__slide p-4">
								<motion.div
									initial={{ scale: 0 }}
									whileInView={{ scale: 1 }}
									transition={{
										duration: 0.5,
										ease: 'easeOut'
									}}
									className="flex flex-col gap-4 justify-center items-center"
								>
									<svg viewBox="0 0 177 168" className="w-full">
										<defs>
											<pattern
												id={`pattern-${index}`}
												patternUnits="userSpaceOnUse"
												width="177"
												height="168"
											>
												<rect
													width="177"
													height="168"
													fill={index % 2 === 0 ? '#EB63B5' : '#98CC94'}
												/>
												<image
													href={item?.image_url}
													x="10"
													y="15"
													width="157"
													height="148"
													preserveAspectRatio="xMidYMid slice"
												/>
											</pattern>
										</defs>

										<path
											d="M177 41.9364C177 26.4545 165.219 13.5154 149.805 12.0679L32.8049 1.08064C15.2059 -0.57205 0 13.2728 0 30.9492V138C0 154.569 13.4315 168 30 168H147C163.569 168 177 154.569 177 138V41.9364Z"
											fill={`url(#pattern-${index})`}
										/>
									</svg>
									<motion.div
										initial={{ scale: 0 }}
										whileInView={{ scale: 1 }}
										transition={{
											delay: 0.2,
											duration: 0.5,
											ease: 'easeOut'
										}}
									>
										<div className="text-center font-bold md:text-2xl text-xl text-blue-600">
											{item.name}
										</div>
										<div className="text-center font-bold md:text-2xl text-xl text-blue-600">
											Rp {currency(Number(item.sales_price))}
										</div>
									</motion.div>
								</motion.div>
							</div>
						))}
					</div>
					<div className="flex justify-center mt-4 gap-2">
						{products.map((_, idx) => (
							<button
								key={idx}
								onClick={() => slider?.current?.moveToIdx(idx)}
								className={`w-2 h-2 rounded-full transition-all ${
									currentSlide === idx ? 'bg-blue-600 w-8' : 'bg-blue-100'
								}`}
							/>
						))}
					</div>
				</div>
			</section>
			<Footer />
		</Fragment>
	)
}
